// Map our backend icon hints to Font Awesome icon names registered in
// main.js. Anything unmapped falls back to a neutral info glyph.
export const ENRICHMENT_ICONS = {
  'map-pin': 'location-dot',
  shield: 'shield-halved',
  search: 'magnifying-glass',
  activity: 'chart-line',
  upload: 'upload',
}

export function enrichmentIcon(hint) {
  return ENRICHMENT_ICONS[hint] || 'circle-info'
}
